<template>
  <sidebar :addTitle="$t('MRMR.Qp.AddNew')" :editTitle="$t('MRMR.Qp.Edit')" :isSidebarActive="isSidebarActive"
    :data="data" @onEditData="editData" @closeSidebar="closeSidebar">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" title=""
        subtitle="" :nextButtonText="$t('Next')" :backButtonText="$t('Back')" :finishButtonText="$t('Submit')"
        @on-complete="handleSubmit(submitData)">
        <tab-content :title="$t('MRMR.Qp.Step1')" class="mb-2" :before-change="validateStep1">
          <ValidationObserver ref="step1Observer">
            <div>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('MRMR.Qp.Name')" rules="required" v-slot="{ errors }">
                    <validated-input :label="$t('MRMR.Qp.Name')" v-model="model.name"></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('MRMR.Qp.Email')"
                    :rules="{ regex: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, required: true }"
                    v-slot="{ errors }">
                    <validated-input :label="$t('MRMR.Qp.Email')" v-model="model.email"></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('MRMR.Qp.Occupation')" rules="required" v-slot="{ errors }">
                    <form-label>{{$t('MRMR.Qp.Occupation')}}</form-label>
                    <v-select label="name" :options="qpOccupations" v-model="model.occupation" :reduce="p => p.id"
                      :clearable="false" class="w-full flex-end pr-3 update-type-select" />
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>

                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col vs-w="6" class="mr-5">
                  <form-label>{{$t('MRMR.Qp.HireDate')}}</form-label>
                  <ValidationProvider :name="$t('MRMR.Qp.HireDate')" rules="required" v-slot="{ errors }">
                    <datepicker format="yyyy-MM-dd" :placeholder="$t('MRMR.Qp.HireDate')" v-model="model.hireDate">
                    </datepicker>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>

              <vs-row class="mb-3">

                <vs-col vs-w="6" class="mr-5">
                  <form-label>{{ $t('MRMR.Qp.WorkExperience') }}</form-label>
                  <ValidationProvider :name="$t('MRMR.Qp.WorkExperience')" rules="required" v-slot="{ errors }">

                    <datepicker v-show="workExperiencePickerIsOpen" ref="workExperiencePicker"
                      @closed="workExperiencePickerClosed()" format="yyyy-MM-dd"
                      :placeholder="$t('MRMR.Qp.WorkExperience')" :open-date="model.hireDate"
                      v-model="model.startOfWorkExperienceDate"></datepicker>

                    <!--
                      This structure below represents the same DOM structure that is rendered by 
                      the component.
                     -->
                    <span v-show="!workExperiencePickerIsOpen">
                      <div class="vdp-datepicker">
                        <div>
                          <input @click="openWorkExperiencePicker()" :placeholder="$t('MRMR.Qp.WorkExperience')"
                            type="text" v-model="workExperience" />
                        </div>
                      </div>
                    </span>

                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>

              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <form-label>{{$t('MRMR.Qp.Comments')}}</form-label>
                  <vs-textarea v-model="model.comments" class="w-full" height="100px" name="comments" />
                </vs-col>
              </vs-row>

            </div>
          </ValidationObserver>
        </tab-content>
        <tab-content :title="$t('MRMR.Qp.Step2')" class="mb-2" :before-change="validateStep2">
          <vs-row>
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="7" vs-sm="7" vs-xs="12">
              <form-label>{{$t('MRMR.Qp.ProfessionalOrderRegistrations')}}</form-label>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-lg="4" vs-sm="4" vs-xs="12" class="m-3">
              <feather-icon icon="PlusIcon" class="cursor-pointer" svg-classes="h-6 w-6"
                @click="addProfessionalOrder()" />
            </vs-col>
          </vs-row>
          <vs-row v-for="(listItem, index) in model.professionalOrderRegistrations" :key="`professionalOrder-${index}`">
            <vs-col vs-w="5">
              <ValidationProvider ref="professionalOrderNames" :name="$t('MRMR.Qp.ProfessionalOrderName')" rules="required" v-slot="{ errors }">
                <FormLabel>{{$t('MRMR.Qp.ProfessionalOrderName')}}</FormLabel>
                <v-select
                        label="name"
                        :options="professionalOrders"
                        v-model="listItem.professionalOrderId"
                        :reduce="p => p.id"
                        class="mr-2"
                      />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
            <vs-col vs-w="5">
              <ValidationProvider ref="professionalOrderRegistrationNumbers" :name="$t('MRMR.Qp.RegistrationNumber')" rules="required" v-slot="{ errors }">
                <validated-input class="ml-2" :label="$t('MRMR.Qp.RegistrationNumber')"
                  v-model="listItem.registrationNumber"></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
            <vs-col vs-w="2" class="deleteIcon">
              <feather-icon icon="TrashIcon" class="cursor-pointer" svg-classes="h-6 w-6"
                @click="removeProfessionalOrder(index)" />
            </vs-col>
          </vs-row>
          <vs-divider />
        </tab-content>
        <tab-content :title="$t('MRMR.Qp.Step3')" class="mb-2">
          <vs-row>
            <vs-col vs-w="12">
              <form-label>{{$t('MRMR.Qp.AllowedProjects')}}</form-label>
            </vs-col>
            <vs-col vs-w="12">
              <vs-row>
                <vs-col vs-w="6">
                  <vs-button @click="selectAll" color="primary" class="mb-2">{{$t('MRMR.Qp.SelectAll')}}</vs-button>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-button @click="deselectAll" color="danger" class="mb-2">{{$t('MRMR.Qp.DeselectAll')}}</vs-button>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-w="4" v-for="(item, index) in enabledProjects" :key="`project-${index}`">
              <vs-checkbox v-model="checkedProjects" :vs-value="item.id">{{ item.name }}</vs-checkbox>
            </vs-col>
          </vs-row>
        </tab-content>
      </form-wizard>
    </ValidationObserver>
  </sidebar>
</template>

<script>

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "../../../../../shared/components";
import { FormWizard, TabContent } from "vue-form-wizard";
import qpOccupationsEnum from "../../../QPOccupationEnum";
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import ApplicationModuleEnum from "../../../ApplicationModuleEnum";
import dateman from "@/app/shared/dateman";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormLabel,
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    Datepicker,
    FormWizard,
    TabContent,
    vSelect
  },
  data() {
    return {
      model : { 
        id: 0,
        name: "",
        email: "",
        occupation: null,
        hireDate: null,
        startOfWorkExperienceDate: null,
        comments: "",

        professionalOrderRegistrations: [],
        allowedProjects: []
      },
      qpOccupations: qpOccupationsEnum.definition,

      checkedProjects: [],

      workExperiencePickerIsOpen: false
    };
  },
  computed: {
    enabledProjects() {
      const items = this.$store.state.mrmr.projects.filter(x => x.enabledModules & ApplicationModuleEnum.MRMR === ApplicationModuleEnum.MRMR);
      return items.sort((a, b) => { return (a.name < b.name) ? -1 : 1 });
    },
    workExperience() {
      if (!this.model.startOfWorkExperienceDate) return "";
      const experienceDateAsDate = new Date(this.model.startOfWorkExperienceDate);
      const nbOfDays = dateman.dayDiffFromToday(experienceDateAsDate);
      const fullDiff = dateman.fullDiff(nbOfDays);

      if (fullDiff.years > 1) {
        return `${fullDiff.years} ${this.$t("MRMR.Qp.Years")}`;
      } else if (fullDiff.years === 1) {
        return `${fullDiff.years} ${this.$t("MRMR.Qp.Year")}`;
      } else if (fullDiff.months > 1) {
        return `${fullDiff.months} ${this.$t("MRMR.Qp.Months")}`;
      } else if (fullDiff.months === 1) {
        return `${fullDiff.months} ${this.$t("MRMR.Qp.Month")}`;
      } else if (fullDiff.days > 1) {
        return `${fullDiff.days} ${this.$t("MRMR.Qp.Days")}`;
      } else if (fullDiff.days === 1) {
        return `${fullDiff.days} ${this.$t("MRMR.Qp.Day")}`;
      }

      return "";
    },
    professionalOrders() {
      return this.$store.state.mrmr.professionalOrders;
    }
  },
  methods: {
    selectAll() {
      this.enabledProjects.forEach(x => {
        this.checkedProjects.push(x.id);
      });
    },
    deselectAll() {
      this.checkedProjects = [];
    },
    editData() {
      this.model = JSON.parse(JSON.stringify(this.data));
      if (this.model.hireDate) {
        this.model.hireDate = new Date(this.model.hireDate);
      }
      this.checkedProjects = [];

      this.allowedProjectsToVModel();
      this.$refs.wizard.reset();
      this.$refs.step1Observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.step1Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        const poRefs = this.$refs.professionalOrderNames;
        const prnRefs = this.$refs.professionalOrderRegistrationNumbers;
        const refs = [...poRefs, ...prnRefs];

        const validation = refs.map(async r => r.validate());
        Promise.all(validation).then(results => {
          const invalid = results.some(r => r.valid === false);
          if (invalid) {
            reject("correct all values");
            return;
          }

          resolve(true);
        });
      });
    },
    addProfessionalOrder() {
      this.model.professionalOrderRegistrations.push({
        id: 0,
        professionalOrderId: undefined,
        registrationNumber: ""
      });
    },
    removeProfessionalOrder(index) {
      this.model.professionalOrderRegistrations.splice(index, 1);
    },
    
    allowedProjectsToVModel() {
      if (!this.model.allowedProjects) {
        return;
      }
      this.checkedProjects = this.model.allowedProjects.map(x => x.projectId);
    },

    vModelToAllowedProjects() {
      if (!this.model.allowedProjects) {
        this.model.allowedProjects = [];
      }
      const existing = this.model.allowedProjects.map(x => x.projectId);
      const toAdd = this.checkedProjects.filter(x => !existing.includes(x));
      const toRemove = existing.filter(x => !this.checkedProjects.includes(x));
      
      toRemove.forEach(x => {
        const idx = this.model.allowedProjects.findIndex(y => y.projectId === x);
        this.model.allowedProjects.splice(idx, 1);
      });

      toAdd.forEach(x => {
        this.model.allowedProjects.push({
          id: 0,
          qpId: this.model.id,
          projectId: x
        });
      });

      this.model.allowedProjects = this.model.allowedProjects.filter(function(item, pos, self) {
        return self.findIndex(_ => _.projectId === item.projectId) === pos;
      });
    },
    async submitData() {
      this.$refs.step1Observer.validate().then(result => {
        if (result) {
          this.vModelToAllowedProjects();
          const obj = this.model;
           
          if (Object.prototype.toString.call(this.model.qpDate) === "[object Date]") {
            obj.qpDate = this.$options.filters.toDate(this.model.qpDate);
          }
          else {
            obj.qpDate = this.model.qpDate;
          }

          this.$vs.loading();
          if (this.model.id !== null && this.model.id > 0) {
            this.$store.dispatch("mrmr/updateQP", obj).then((result) => {
              this.$emit("onQpUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("mrmr/addQP", obj).then((result) => {
              this.$emit("onQpInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    },

    openWorkExperiencePicker() {
      this.workExperiencePickerIsOpen = true;
      this.$refs.workExperiencePicker.showCalendar();
    },
    
    workExperiencePickerClosed() {
      this.workExperiencePickerIsOpen = false;
    }
  }
};
</script>

<style lang="scss">

.vs-sidebar {
  width: 550px !important;
}

// hack to hide the clear button because the v-select clearable props doesn,t work
.update-type-select .vs__clear {
  display: none !important;
}

.deleteIcon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
